import React from 'react';
import './WhatWeDo.css';

const WhatWeDo = () => {
    return (
        <section id="about-partsol" className="what-we-do">
            <div className="what-we-do-container">
                {/* Centered Who We Are content */}
                <div className="what-we-do-header">
                    <span className="section-label">About Partsol</span>
                    <h2 className="what-we-do-title">Partsol: Who We Are</h2>
                    <p className="what-we-do-text">
                        Partsol is a pioneer in the field of Artificial General Intelligence ("AGI"),
                        a form of artificial intelligence that exhibits or simulates human behavior.
                        Our proprietary methodologies, algorithms, and enabling technologies operate
                        as a unified, general-purpose cognitive engine capable of delivering insights
                        across an unlimited range of domains.
                    </p>
                </div>

                {/* Vision and Mission boxes side by side below */}
                <div className="vision-mission-row">
                    <div className="vision-box">
                        <div className="box-icon">
                            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <circle cx="12" cy="12" r="10" />
                                <circle cx="12" cy="12" r="6" />
                                <circle cx="12" cy="12" r="2" />
                            </svg>
                        </div>
                        <h3 className="box-title">Our Vision</h3>
                        <p className="box-text">
                            To be the global leader in Artificial General Intelligence,
                            transforming how organizations make mission-critical decisions
                            through precision-engineered cognitive solutions.
                        </p>
                    </div>

                    <div className="mission-box">
                        <div className="box-icon">
                            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <polygon points="12 2 2 7 12 12 22 7 12 2" />
                                <polyline points="2 17 12 22 22 17" />
                                <polyline points="2 12 12 17 22 12" />
                            </svg>
                        </div>
                        <h3 className="box-title">Our Mission</h3>
                        <p className="box-text">
                            Partsol's mission is to bring this transformative capability into the mainstream
                            by making advanced, human-level intelligence accessible, practical, and seamlessly
                            integrated into everyday systems, workflows, and decision-making.
                        </p>
                        <p className="box-text secondary">
                            We are moving AGI out of the realm of research and into real-world applications
                            where it can empower organizations, elevate human potential, and unlock entirely
                            new opportunities for innovation and growth.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default WhatWeDo;
